import { Controller } from "stimulus";

export default class extends Controller {
  static targets = [
    "form",
    "nameField",
    "emailField",
    "whatsappField",
    "messageField",
    "submitButton",
    "errorContainer",
  ];

  connect() {
    this.setupRecaptcha();
    this.initializeModal();
  }

  initializeModal() {
    // Initialize Semantic UI modal with custom settings
    $("#contact-advertiser-modal").modal({
      closable: true,
      onApprove: function () {
        // Prevent modal from auto-closing on approve button click
        return false;
      },
    });
  }

  async submit(event) {
    event.preventDefault();
    event.stopPropagation();

    // Clear previous errors
    this.clearErrors();

    // Get reCAPTCHA token
    const recaptchaToken = await this.getRecaptchaToken();

    // Prepare form data
    const formData = new FormData(this.formTarget);
    formData.set("recaptcha_token", recaptchaToken);

    // Disable submit button
    this.submitButtonTarget.classList.add("loading", "disabled");

    try {
      const response = await fetch(this.formTarget.action, {
        method: "POST",
        headers: {
          "X-CSRF-Token": this.csrfToken,
          Accept: "application/json",
        },
        body: formData,
      });

      const data = await response.json();

      if (data.success) {
        if (data.event_id && typeof window.fbq === "function") {
          const content = {
            content_type: "product",
            content_ids: [data.catalog_item_id],
            content_name: data.content_name,
          };
          window.fbq("track", "Lead", content, { eventID: data.event_id });
        }

        $("#contact-advertiser-modal").modal("hide");
        this.showSuccessToast(
          data.message || "Recebemos seu contato. O vendedor foi avisado e a Agro2Business vai te retornar.",
        );
      } else {
        // Show errors - DO NOT close modal
        this.displayErrors(data.errors);
        this.submitButtonTarget.classList.remove("loading", "disabled");
      }
    } catch (error) {
      console.error("Error:", error);
      this.showErrorToast("Algo deu errado. Por favor, tente novamente.");
      this.submitButtonTarget.classList.remove("loading", "disabled");
    }
  }

  clearErrors() {
    // Remove error classes from fields
    this.formTarget.querySelectorAll(".field.error").forEach((field) => {
      field.classList.remove("error");
    });

    // Clear error container if exists
    if (this.hasErrorContainerTarget) {
      this.errorContainerTarget.innerHTML = "";
      this.errorContainerTarget.style.display = "none";
    }
  }

  displayErrors(errors) {
    if (!errors || errors.length === 0) return;

    // Show errors in toast
    errors.forEach((error) => {
      this.showErrorToast(error);
    });

    // Also display in form if error container exists
    if (this.hasErrorContainerTarget) {
      const errorHtml = `
        <div class="ui error message visible">
          <i class="close icon"></i>
          <div class="header">Por favor, corrija os seguintes erros:</div>
          <ul class="list">
            ${errors.map((error) => `<li>${error}</li>`).join("")}
          </ul>
        </div>
      `;
      this.errorContainerTarget.innerHTML = errorHtml;
      this.errorContainerTarget.style.display = "block";

      // Add close functionality
      this.errorContainerTarget
        .querySelector(".close.icon")
        ?.addEventListener("click", () => {
          this.clearErrors();
        });
    }

    // Mark fields as error (basic implementation)
    this.markFieldsWithErrors(errors);
  }

  markFieldsWithErrors(errors) {
    const fieldMap = {
      Nome: this.nameFieldTarget?.closest(".field"),
      WhatsApp: this.whatsappFieldTarget?.closest(".field"),
      Mensagem: this.messageFieldTarget?.closest(".field"),
    };

    errors.forEach((error) => {
      Object.keys(fieldMap).forEach((fieldName) => {
        if (error.includes(fieldName) && fieldMap[fieldName]) {
          fieldMap[fieldName].classList.add("error");
        }
      });
    });
  }

  showSuccessToast(message) {
    if (typeof $("body").toast === "function") {
      $("body").toast({
        class: "success",
        position: "bottom center",
        displayTime: 3000,
        message: message,
        showIcon: "check",
      });
    }
  }

  showErrorToast(message) {
    if (typeof $("body").toast === "function") {
      $("body").toast({
        class: "error",
        position: "bottom center",
        displayTime: 5000,
        message: message,
        showIcon: "exclamation triangle",
      });
    }
  }

  async getRecaptchaToken() {
    if (typeof grecaptcha === "undefined") {
      console.warn("reCAPTCHA not loaded");
      return "";
    }

    const siteKey = document.getElementById("recaptcha_site_key")?.value;
    if (!siteKey) {
      console.warn("reCAPTCHA site key not found");
      return "";
    }

    try {
      const token = await grecaptcha.execute(siteKey, { action: "submit" });
      return token;
    } catch (error) {
      console.error("reCAPTCHA error:", error);
      return "";
    }
  }

  setupRecaptcha() {
    // Load reCAPTCHA if not already loaded
    const siteKey = document.getElementById("recaptcha_site_key")?.value;
    if (!siteKey) return;

    if (typeof grecaptcha === "undefined") {
      const script = document.createElement("script");
      script.src = `https://www.google.com/recaptcha/api.js?render=${siteKey}`;
      document.head.appendChild(script);
    }
  }

  get csrfToken() {
    return document.querySelector('meta[name="csrf-token"]')?.content || "";
  }
}
